var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTopSellersIcon = function SvgTopSellersIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M10 2.44 4.6 7.86h2.91c.59 0 1.067.477 1.067 1.07v8.928h2.846V8.93c0-.593.476-1.07 1.067-1.07H15.4zM8.995.418a1.42 1.42 0 0 1 2.014 0l7.116 7.142c.409.41.529 1.022.307 1.558a1.42 1.42 0 0 1-1.317.884h-3.557v7.856A2.14 2.14 0 0 1 11.423 20H8.577a2.14 2.14 0 0 1-2.135-2.142v-7.856H2.884a1.434 1.434 0 0 1-1.01-2.442L8.99.418z"
  })));
};
export default SvgTopSellersIcon;